export enum HttpRequestStatus {
  NOOP = 'NOOP',
  ONGOING = 'ON_GOING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}
